import { usePortalTranslations } from 'portals-platform-lib';
import { usePortalData } from '../data/usePortalData';
export function usePortalPageTitle() {
  var _portalData$data;
  const portalData = usePortalData();
  const {
    portalText
  } = usePortalTranslations();
  return portalText('SUPPORT_SPACE_PAGE_TITLE') || ((_portalData$data = portalData.data) === null || _portalData$data === void 0 || (_portalData$data = _portalData$data.settings) === null || _portalData$data === void 0 ? void 0 : _portalData$data.pageTitle) || undefined;
}